module.exports = __webpack_public_path__ + "img/DFD9C2_B5AE92_F9F7EA_C4C4A4-256px.7a271055.png";